import { useCallback } from 'react'
import { useTranslation as useI18nTranslation } from 'react-i18next'
import { SUPPORTED_LANGUAGES, LANGUAGE_META, type SupportedLanguage } from './config.js'

/**
 * Hook for accessing translations with proper typing.
 */
export function useTranslation(namespace?: string | string[]) {
  const { t, i18n, ready } = useI18nTranslation(namespace)

  const changeLanguage = useCallback(
    (lang: SupportedLanguage) => {
      return i18n.changeLanguage(lang)
    },
    [i18n]
  )

  const currentLanguage = i18n.language as SupportedLanguage

  return {
    t,
    i18n,
    ready,
    currentLanguage,
    changeLanguage,
    languages: SUPPORTED_LANGUAGES,
    languageMeta: LANGUAGE_META,
  }
}

/**
 * Hook specifically for the language switcher component.
 */
export function useLanguageSwitcher() {
  const { currentLanguage, changeLanguage, languages, languageMeta } = useTranslation()

  return {
    currentLanguage,
    changeLanguage,
    languages,
    languageMeta,
  }
}
